import React, { useState, useEffect } from 'react';
import { onAuthStateChanged, signInWithCustomToken, signOut } from 'firebase/auth';
import { doc, getDoc } from 'firebase/firestore';
import { auth, db, appId } from './utils/firebase';

import PublicFront from './views/PublicFront';
import LoginGate from './components/LoginGate';
import TertiaryHub from './components/TertiaryHub';
import UnauthorizedSplash from './views/UnauthorizedSplash';

const App = () => {
    const [viewState, setViewState] = useState('checking'); 
    const [handle, setHandle] = useState('');
    const [clearance, setClearance] = useState('LEVEL 1');

    useEffect(() => {
        const initAuth = async () => {
            // Support for Canvas injected token (if present)
            if (typeof window.__initial_auth_token !== 'undefined' && window.__initial_auth_token) {
                try { await signInWithCustomToken(auth, window.__initial_auth_token); } 
                catch (err) { console.warn("Canvas token auth failed", err); }
            }
        };
        initAuth();

        const unsub = onAuthStateChanged(auth, async (u) => {
            if (u) {
                try {
                    const userDocRef = doc(db, 'artifacts', appId, 'public', 'data', 'users', u.uid);
                    const snap = await getDoc(userDocRef);
                    if (snap.exists()) {
                        // Registered but not approved yet: end the session. (A missing profile is NOT treated this way,
                        // because a brand-new registration signs in a moment before its profile document is written.)
                        if (snap.data().status === 'PENDING') { await signOut(auth); return; }
                        const c = snap.data().clearance;
                        setHandle(snap.data().handle || 'Operative');
                        setClearance(c || 'LEVEL 1');
                        if (c === 'FIELD OP' || c === 'LEVEL 0') {
                            setViewState('unauthorized'); return;
                        }
                    } else { 
                        setHandle(u.email ? u.email.split('@')[0] : 'Admin'); 
                        setClearance('LEVEL 1');
                    }
                } catch (e) {
                    console.error("Auth check issue:", e);
                    setHandle(u.email ? u.email.split('@')[0] : 'Admin');
                    setClearance('LEVEL 1');
                }
                setViewState('hub');
            } else { setViewState(prev => (prev === 'login' ? 'login' : 'public')); }
        });
        return () => unsub();
    }, []);

    if (viewState === 'checking') return <div className="min-h-screen bg-black flex items-center justify-center text-gray-500 font-mono text-xs">SYNCHRONIZING...</div>;

    const handleLogout = async () => { await signOut(auth); setViewState('public'); };

    return (
        <div className="antialiased font-sans h-screen w-full flex flex-col overflow-hidden bg-black text-white">
            {viewState === 'public' && <PublicFront onBreach={() => setViewState('login')} />}
            {viewState === 'login' && <LoginGate onSuccess={(target) => setViewState(target || 'hub')} onClose={() => setViewState('public')} setHandle={setHandle} setClearance={setClearance} />}
            {viewState === 'hub' && <TertiaryHub onExit={handleLogout} handle={handle} clearance={clearance} />}
            {viewState === 'unauthorized' && <UnauthorizedSplash onExit={handleLogout} />}
        </div>
    );
};

export default App;